module.exports = __webpack_public_path__ + "static/folder-fad9646298b672446860fa59c05e7a86.gif";